<div class="component" (click)="onClickComponent()" title="Incluir Avalista">
    <span class="plus fa fa-plus"></span>
    <span class="user fa fa-user"></span>
</div>